import { render, staticRenderFns } from "./codAdmin.vue?vue&type=template&id=6a4c72ae"
import script from "./codAdmin.vue?vue&type=script&lang=js"
export * from "./codAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports